/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Enum generated from HubAPI C# code.
export enum ActivityStatusEnum {
  NotApplicable = 0,
  Incomplete = 1,
  Dismantled = 2,
  OnHire = 3,
  OffHire = 4,
  InspectionNoDefects = 5,
  InspectionDefectsFixed = 6,
  InspectionUnSafeScaffold = 7,
  InspectionDefectsNotFixed = 8,
}
